export function omitReduxProps(props = {}) {
    const clonedObject = Object.assign({}, props)
    delete clonedObject.history
    delete clonedObject.location
    delete clonedObject.match
    delete clonedObject.staticContext
    delete clonedObject.dispatch

    return clonedObject
}

export function isUnauthenticated(error) {
    const status = (error?.response && error?.response?.status) ? error.response.status : null;
    const unauthorizedErrors = ["The user is not authenticated", "No current user", "Request failed with status code 401"];
    
    return unauthorizedErrors.includes(error) || status === 401
}

export function getSearchParam() {
  return ((window.location.pathname.indexOf("/search/") === 0 && window.location.pathname.split("/").slice(-1)?.[0]) || undefined) ?? "";
}

export function getApplDetailParams() {
    const [_, __, applicantEmployeeId, programId, term] = window.location.pathname.split('/') ?? []; // eslint-disable-line
    return { applicantEmployeeId, programId, term };
}

export const sortByAttribute = (array, key ) => {
    return array.sort((a,b) => {
      const valA = a[key];
      const valB = b[key];
      if(valA < valB){
        return -1;
      } else if(valB > valA)
      return 1;
       else {
        return 0;
       }
    })
  }
  
export function formatDatetime(dttm) { return dttm ? new Date(dttm).toLocaleString() : "-"; }

export function getSevenDaysFromToday() {
    let sevenDaysFromToday = new Date();
    sevenDaysFromToday.setDate(sevenDaysFromToday.getDate() + 7);
    sevenDaysFromToday.setHours(0);
    sevenDaysFromToday.setMinutes(0);
    sevenDaysFromToday.setSeconds(0);
    sevenDaysFromToday.setMilliseconds(0);
    return sevenDaysFromToday;
}

export function addBusinessDays(startDate, businessDays) {
  const date = new Date(startDate);
  let daysAdded = 0;
  
  while (daysAdded < businessDays) {
    const dayOfWeek = date.getDay(); 
    
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysAdded++;
    }
    
    if (daysAdded < businessDays) {
      date.setDate(date.getDate() + 1);
    }
  }
  
  date.setHours(17, 0, 0, 0);
  
  return date;
}

export const getDefaultGradingTemplate = (gradingTemplates) => {
    const templateArray = Object.values(gradingTemplates)
    return (gradingTemplates && templateArray.length === 1) ? templateArray[0].key : {}
}

export function addSpacesToCamelCase(str) {
    return str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()).trim();
}

export function conjugate(type, count) {
  switch(type) {
    case 'isAre':
      return count === 1 ? 'is' : 'are'
    case 'trailingS':
      return count === 1 ? '' : 's'
    default:
      return null;
  }
}

export function openBypassPopupBlocker(url) {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}